import { ReactNode } from 'react'
import { createUseStyles } from 'react-jss'
import { Colors } from '../constants/colors'
import Card from './Card'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit } from '@fortawesome/free-solid-svg-icons'
import { useTranslation } from 'react-i18next'

interface Props {
    title: string
    color?: string
    titleColor?: string
    children: ReactNode
    className?: string
    style?: React.CSSProperties | undefined
    headerStyle?: React.CSSProperties | undefined
    enableEdit?: boolean
    onEditClick?: () => void
}

const InfoCard = ({title, color, titleColor, children, className, style, headerStyle, enableEdit, onEditClick}: Props) => {
    const styles = useStyles()
    const {t} = useTranslation(['common']);
    return (
        <Card className={`${styles.infoCard} ${className}`} style={color != null ? {...style, backgroundColor: color} : {...style}}>
            <div className={styles.infoCardHeader} style={titleColor != null ? {...headerStyle, color: titleColor} : {...headerStyle}}>
                <h4>{title}</h4>
                {enableEdit &&
                <div className={styles.toolbar}>
                    <FontAwesomeIcon
                        className={styles.button}
                        icon={faEdit}
                        color={Colors.gray1}
                        title={t('edit', {ns: 'common'})}
                        onClick={() => onEditClick && onEditClick()}
                    />
                </div>
                }
            </div>
            <div style={{flex: 1}}>
                {children}
            </div>
        </Card>
    )
}

export default InfoCard

const useStyles = createUseStyles({
    infoCard: {
        display: 'flex',
        flexDirection: 'column',
        rowGap: 10,
        marginBottom: 20
    },
    infoCardHeader: {
        color: Colors.euro_800,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    toolbar: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        gap: 10
    },
    button: {
        transition: '0.4s',
        '&:hover': {
        color: Colors.euro_600,
        cursor: 'pointer',
        }
    }
})